var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Media/ Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.4001 8.6999V3.7999C2.4001 3.0267 3.0269 2.3999 3.8001 2.3999L12.2001 2.3999C12.9733 2.3999 13.6001 3.0267 13.6001 3.7999V8.6999M2.4001 8.6999V12.1999C2.4001 12.9731 3.0269 13.5999 3.8001 13.5999H12.2001C12.9733 13.5999 13.6001 12.9731 13.6001 12.1999V8.6999M2.4001 8.6999H4.21015C4.3958 8.6999 4.57385 8.77365 4.70512 8.90493L6.39507 10.5949C6.52635 10.7262 6.7044 10.7999 6.89005 10.7999H9.11015C9.2958 10.7999 9.47385 10.7262 9.60512 10.5949L11.2951 8.90493C11.4263 8.77365 11.6044 8.6999 11.79 8.6999H13.6001",
    stroke: "#9F9F9F",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.01ccb51c9a5e37dbd69052e4132883c5.svg";
export { ForwardRef as ReactComponent };